<template>
  <div class="service-config-page">
    <template v-if="isSuperTenant">
      <div class="search-form">
        <a-form layout="inline">
          <a-form-item label="租户用户名">
            <a-input v-model="searchForm.chargeUsername" placeholder="请输入租户用户名" allowClear />
          </a-form-item>
          <a-form-item label="水司名称">
            <a-input v-model="searchForm.tenantName" placeholder="请输入水司名称" allowClear />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleSearch">
              <a-icon type="search" /> 查询
            </a-button>
            <a-button style="margin-left: 8px" @click="handleReset">
              <a-icon type="reload" /> 重置
            </a-button>
            <a-button style="margin-left: 8px" type="danger" :disabled="selectedRowKeys.length === 0" @click="handleBatchDelete">
              <a-icon type="delete" /> 删除
            </a-button>
            <a-button style="margin-left: 8px" type="primary" @click="handleAdd">
              <a-icon type="plus" /> 新增配置
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <div class="table-container">
        <a-table
          :columns="columns"
          :data-source="dataList"
          :pagination="pagination"
          :loading="loading"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          rowKey="id"
          @change="handleTableChange"
        >
          <template slot="pushStatus" slot-scope="text, record">
            <a-switch
              :checked="text === 1 || text === true"
              checked-children="启用"
              un-checked-children="禁用"
              @change="(checked) => handleTogglePush(record, checked)"
            />
          </template>
          <template slot="operation" slot-scope="text, record">
            <a @click="handleEdit(record)">编辑</a>
          </template>
        </a-table>
      </div>
    </template>

    <template v-else>
      <a-card title="基本信息" :bordered="false" class="section-card">
        <template slot="extra">
          <a-button type="primary" icon="sync" size="small" :loading="syncInfoLoading" @click="handleSyncWxInfo">同步</a-button>
        </template>
        <div class="base-info" >
          <div class="info-item info-avatar">
            <span class="label">服务号头像:</span>
            <a-avatar
              :size="56"
              :src="wxInfo.appPhoto || ''"
              icon="user"
            />
          </div>
          <div class="info-item"><span class="label">认证主体:</span><span class="value">{{ wxInfo.tenantName || '-' }}</span></div>
          <div class="info-item"><span class="label">服务号AppID:</span><span class="value">{{ wxInfo.appId || '-' }}</span></div>
          <div class="info-item"><span class="label">绑定时间:</span><span class="value">{{ wxInfo.createTime || '-' }}</span></div>
          <div class="info-item"><span class="label">关注用户数:</span><span class="value">{{ wxInfo.appFollowNum || 0 }}</span></div>
        </div>
      </a-card>
      <a-card title="消息模板列表" :bordered="false" class="section-card">
        <div class="search-form template-search">
          <a-form layout="inline">
            <a-form-item label="模板名称">
              <a-input v-model="templateQuery.templateName" placeholder="请输入模板名称" allowClear />
            </a-form-item>
            <a-form-item label="启用状态">
              <a-select v-model="templateQuery.isApply" placeholder="请选择" allow-clear style="width: 120px">
                <a-select-option :value="1">启用</a-select-option>
                <a-select-option :value="0">禁用</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" @click="handleTemplateSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="handleTemplateReset">重置</a-button>
            </a-form-item>
            <a-button type="primary" icon="sync" class="sync-btn" :loading="syncLoading" @click="handleSyncTemplate">同步微信消息模板</a-button>
          </a-form>
        </div>
        <div class="template-sync-time">
          <a-icon type="clock-circle" />
          <span>最后同步时间：</span>
          <span class="time-value">{{ templateSysTime || '—' }}</span>
        </div>

        <a-table
          :columns="templateColumns"
          :data-source="templateList"
          :pagination="templatePagination"
          :loading="templateLoading"
          rowKey="id"
          @change="handleTemplateTableChange"
        >
          <template slot="templateStatus" slot-scope="text, record">
            <a-switch
              :checked="text === 1 || text === true"
              :loading="templateStatusLoadingMap[record.id || record.templateId]"
              checked-children="启用"
              un-checked-children="禁用"
              @change="(checked) => handleToggleTemplateStatus(record, checked)"
            />
          </template>
          <template slot="templateAction" slot-scope="text, record">
            <a @click="handleViewTemplate(record)">详情</a>
          </template>
        </a-table>
      </a-card>
    </template>

    <a-modal :title="modalTitle" :visible="modalVisible" :confirm-loading="modalLoading" @ok="handleModalOk" @cancel="handleModalCancel" width="600px">
      <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-item label="绑定租户" required>
          <a-select v-decorator="['tenantId', { rules: [{ required: true, message: '请选择要绑定的租户' }] }]" placeholder="请选择要绑定的租户">
            <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">
              {{ item.chargeUsername || item.tenantId }} ({{ item.tenantName || '' }})
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="AppID" required>
          <a-input v-decorator="['appId', { rules: [{ required: true, message: '请输入AppID' }] }]" placeholder="请输入AppID" />
        </a-form-item>
        <a-form-item label="AppSecret" required>
          <a-input
            v-decorator="['appSecret', { rules: [{ required: true, message: '请输入AppSecret' }] }]"
            :disabled="appSecretReadonly"
            :placeholder="appSecretReadonly ? 'AppSecret含*号时不允许修改' : '请输入AppSecret'"
          />
        </a-form-item>
        <a-form-item label="水司地址">
          <a-input v-decorator="['address']" placeholder="请输入水司地址（非必填）" />
        </a-form-item>
        <a-form-item label="联系电话">
          <a-input v-decorator="['phone']" placeholder="请输入联系电话（非必填）" />
        </a-form-item>
        <a-form-item label="启用状态" required>
          <a-switch v-decorator="['isApply', { valuePropName: 'checked', initialValue: true }]" checked-children="启用" un-checked-children="禁用" />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      title="模板详情"
      :visible="templateDetailVisible"
      :footer="null"
      width="800px"
      @cancel="templateDetailVisible = false"
    >
      <div class="template-detail-container">
        <a-descriptions bordered :column="2" size="middle" class="detail-descriptions">
          <a-descriptions-item label="模板名称" :span="2">
            <span class="detail-title">{{ templateDetailRecord.title || '-' }}</span>
          </a-descriptions-item>

          <a-descriptions-item label="启用状态">
            <a-badge 
              :status="templateDetailRecord.isApply === 1 || templateDetailRecord.isApply === true ? 'success' : 'error'" 
              :text="templateDetailRecord.isApply === 1 || templateDetailRecord.isApply === true ? '正在使用' : '已禁用'" 
            />
          </a-descriptions-item>
          <a-descriptions-item label="所属租户">
            {{ templateDetailRecord.tenantName || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="创建时间">
            {{ templateDetailRecord.createTime || '-' }}
          </a-descriptions-item>
          <a-descriptions-item label="模板内容" :span="2">
            <div class="template-content-box">
              <div class="content-body" v-html="formatTemplateContent(templateDetailRecord.content)"></div>
            </div>

          </a-descriptions-item>
        </a-descriptions>
      </div>
    </a-modal>
  </div>
</template>

<script>
import storage from 'store'
import { getWxKeyList, addWxKeyConfig, deleteWxKey, selectWxTemplateByTenantId, obtainWxTemplate, updateWxTemplateIsApply, sysWxInfo } from '@/api/serviceConfig'

const SUPER_TENANT_ID = 'default-super-tenant2'

export default {
  name: 'ServiceConfig',
  data() {
    return {
      searchForm: {
        chargeUsername: '',
        tenantName: ''
      },
      columns: [
        { title: '租户用户名', dataIndex: 'chargeUsername', key: 'chargeUsername', width: 120 },
        { title: '水司名称', dataIndex: 'tenantName', key: 'tenantName', width: 150 },
        { title: '水司地址', dataIndex: 'address', key: 'address', width: 220, ellipsis: true },
        { title: '联系电话', dataIndex: 'phone', key: 'phone', width: 140 },
        { title: 'APPID', dataIndex: 'appId', key: 'appId', width: 200 },
        { title: '启用状态', dataIndex: 'isApply', key: 'isApply', width: 140, scopedSlots: { customRender: 'pushStatus' } },
        { title: '绑定时间', dataIndex: 'createTime', key: 'bindTime', width: 160 },
        { title: '最近接口调用时间', dataIndex: 'lastTime', key: 'lastApiCallTime', width: 160 },
        { title: '操作', key: 'operation', width: 100, scopedSlots: { customRender: 'operation' }, fixed: 'right' }
      ],
      dataList: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      selectedRowKeys: [],
      modalVisible: false,
      modalLoading: false,
      appSecretReadonly: false,
      modalTitle: '新增服务号配置',
      form: this.$form.createForm(this),
      isEdit: false,
      editRecord: null,
      tenantList: [],
      wxInfo: {},
      templateQuery: {
        templateName: '',
        isApply: undefined
      },
      templateColumns: [
        { title: '模板名称', dataIndex: 'title', key: 'title', width: 180 },
        { title: '模版内容', dataIndex: 'content', key: 'content', ellipsis: true },
        { title: '启用状态', dataIndex: 'isApply', key: 'isApply', width: 120, scopedSlots: { customRender: 'templateStatus' } },
        { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 180 },
        { title: '操作', key: 'action', width: 100, scopedSlots: { customRender: 'templateAction' } }
      ],
      templateList: [],
      templateSysTime: '',
      templateStatusLoadingMap: {},
      templateDetailVisible: false,
      templateDetailRecord: {},
      templateLoading: false,
      syncInfoLoading: false,
      syncLoading: false,
      templatePagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`
      }
    }
  },
  computed: {
    isSuperTenant() {
      return storage.get('tenantId') === SUPER_TENANT_ID
    }
  },
  created() {
    if (this.isSuperTenant) {
      this.loadData()
      this.loadTenantList()
    } else {
      this.loadWxInfo()
      this.loadTemplateList()
    }
  },
  methods: {
    loadData() {
      this.loading = true
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.searchForm
      }
      getWxKeyList(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.rows || []
          this.pagination.total = Number(res.total) || 0
        } else {
          this.$message.error(res.message || '获取数据失败')
        }
      }).catch(() => {
        this.$message.error('获取数据失败')
      }).finally(() => {
        this.loading = false
      })
    },
    loadTenantList() {
      this.$http.get('/manager/tenants/all').then(({ data }) => {
        this.tenantList = data || []
      })
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = {
        chargeUsername: '',
        tenantName: ''
      }
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleAdd() {
      this.modalTitle = '新增服务号配置'
      this.appSecretReadonly = false
      this.isEdit = false
      this.editRecord = null
      this.modalVisible = true
      this.$nextTick(() => {
        this.form.resetFields()
      })
    },
    handleEdit(record) {
      this.modalTitle = '编辑服务号配置'
      this.appSecretReadonly = !!(record.appSecret && String(record.appSecret).includes('*'))
      this.isEdit = true
      this.editRecord = record
      this.modalVisible = true
      this.$nextTick(() => {
        this.form.setFieldsValue({
          appName: record.appName,
          tenantId: record.tenantId,
          appId: record.appId,
          appSecret: record.appSecret,
          address: record.address,
          phone: record.phone,
          isApply: record.isApply === 1 || record.isApply === true
        })
      })
    },
    handleModalOk() {
      this.form.validateFields((err, values) => {
        if (err) return
        this.modalLoading = true
        const params = {
          ...values,
          isApply: values.isApply ? 1 : 0,
          ...(this.isEdit ? { id: this.editRecord.id } : {})
        }
        if (this.appSecretReadonly) {
          delete params.appSecret
        }
        addWxKeyConfig(params).then(res => {
          if (res.code === 0) {
            this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
            this.modalVisible = false
            this.loadData()
          } else {
            this.$message.error(res.message || '操作失败')
          }
        }).catch(() => {
          this.$message.error('操作失败')
        }).finally(() => {
          this.modalLoading = false
        })
      })
    },
    handleModalCancel() {
      this.modalVisible = false
      this.appSecretReadonly = false
    },
    handleBatchDelete() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm({
        title: '确认删除',
        content: `确定要删除选中的 ${this.selectedRowKeys.length} 条数据吗？`,
        onOk: () => {
          deleteWxKey({ ids: this.selectedRowKeys }).then(res => {
            if (res.code === 0) {
              this.$message.success('删除成功')
              this.selectedRowKeys = []
              this.loadData()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          }).catch(() => {
            this.$message.error('删除失败')
          })
        }
      })
    },
    handleTogglePush(record, checked) {
      addWxKeyConfig({
        id: record.id,
        isApply: checked ? 1 : 0
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('启用状态修改成功')
          record.isApply = checked ? 1 : 0
        } else {
          this.$message.error(res.message || '启用状态修改失败')
          this.loadData()
        }
      }).catch(() => {
        this.$message.error('启用状态修改失败')
        this.loadData()
      })
    },
    handleSyncWxInfo() {
      this.syncInfoLoading = true
      sysWxInfo().then((res) => {
        if (res.code === 0) {
          this.$message.success('同步成功')
          this.loadWxInfo()
        } else {
          this.$message.error(res.msg || '同步失败')
        }
      }).catch(() => {
        this.$message.error('同步失败')
      }).finally(() => {
        this.syncInfoLoading = false
      })
    },
    loadWxInfo() {
      getWxKeyList({ pageNum: 1, pageSize: 1 }).then(res => {
        if (res.code === 0) {
          const rows = res.rows 
          this.wxInfo = rows[0] || {}
        }
      })
    },
    loadTemplateList() {
      this.templateLoading = true
      const params = {
        ispage: 0,
        pageNum: this.templatePagination.current,
        pageSize: this.templatePagination.pageSize,
        title: this.templateQuery.templateName || undefined,
        isApply: this.templateQuery.isApply
      }
      selectWxTemplateByTenantId(params).then(res => {
        if (res.code === 0) {
          this.templateList = res.rows || res.data?.rows || res.data || []
          this.templatePagination.total = Number(res.total || res.data?.total || 0)
          const st = res.sysTime ?? res.data?.sysTime
          if (st != null && st !== '') {
            this.templateSysTime = st
          }
        } else {
          this.$message.error(res.message || '获取模板列表失败')
        }
      }).catch(() => {
        this.$message.error('获取模板列表失败')
      }).finally(() => {
        this.templateLoading = false
      })
    },
    handleTemplateSearch() {
      this.templatePagination.current = 1
      this.loadTemplateList()
    },
    handleTemplateReset() {
      this.templateQuery = { templateName: '', isApply: undefined }
      this.templatePagination.current = 1
      this.loadTemplateList()
    },
    handleTemplateTableChange(pagination) {
      this.templatePagination.current = pagination.current
      this.templatePagination.pageSize = pagination.pageSize
      this.loadTemplateList()
    },
    handleSyncTemplate() {
      this.syncLoading = true
      obtainWxTemplate().then(res => {
        console.log(res);
        
        if (res.code === 0) {
          this.$message.success('同步成功')
          const st = res.sysTime ?? res.data?.sysTime
          if (st != null && st !== '') {
            this.templateSysTime = st
          }
          this.loadTemplateList()
        } else {
          this.$message.error(res.msg || '同步失败')
        }
      }).catch((res) => {
        this.$message.error(res.data.msg || '同步失败')
      }).finally(() => {
        this.syncLoading = false
      })
    },
    handleToggleTemplateStatus(record, checked) {
      const rowKey = record.id || record.templateId
      this.$set(this.templateStatusLoadingMap, rowKey, true)
      updateWxTemplateIsApply({
        id: record.id != null ? record.id : record.templateId,
        isApply: checked ? 1 : 0
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('模板启用状态修改成功')
          record.isApply = checked ? 1 : 0
          if ((this.templateDetailRecord.id || this.templateDetailRecord.templateId) === rowKey) {
            this.templateDetailRecord.isApply = checked ? 1 : 0
          }
        } else {
          this.$message.error(res.message || '模板启用状态修改失败')
          this.loadTemplateList()
        }
      }).catch(() => {
        this.$message.error('模板启用状态修改失败')
        this.loadTemplateList()
      }).finally(() => {
        this.$set(this.templateStatusLoadingMap, rowKey, false)
      })
    },
    handleViewTemplate(record) {
      this.templateDetailRecord = { ...record }
      this.templateDetailVisible = true
    },
    formatTemplateContent(content) {
      if (!content) return '-'
      // 将 {{...}} 标签高亮
      return content.replace(/\{\{([^{}]+)\}\}/g, '<span class="template-variable">{{\$1}}</span>').replace(/\n/g, '<br/>')
    }
  }
}
</script>

<style lang="less" scoped>
.service-config-page {

  .search-form {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    margin-bottom: 20px;
  }

  .table-container {
    background: #fff;
    padding: 0 0 20px;
    border-radius: 0 0 4px 4px;
  }

  .section-card {
    margin-bottom: 16px;
  }

  .base-info {
    padding: 20px;
    display: grid;
    grid-template-columns: repeat(3, minmax(200px, 1fr));
    gap: 12px 24px;
    background-color: #F3F6FB;
    border-radius: 5px;
  }

  .info-item {
    display: flex;
    align-items: center;

    .label {
      color: rgba(0, 0, 0, 0.45);
      margin-right: 8px;
    }
    .value {
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
    }
  }

  .info-avatar {
    .ant-avatar {
      border: 1px solid #f0f0f0;
      background: #fafafa;
    }
  }

  .template-search {
    margin-bottom: 12px;
  }

  .template-sync-time {
    margin: -4px 0 12px;
    padding: 8px 12px;
    //background: #fafafa;
    border-radius: 4px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.65);

    .anticon {
      margin-right: 6px;
      color: rgba(0, 0, 0, 0.45);
    }

    .time-value {
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
    }
  }

  .sync-btn {
    float: right;
  }

  .template-content-box {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 12px 16px;
    margin-bottom: 8px;
    font-family: Consolas, Monaco, 'Courier New', monospace;
    color: #495057;

    .content-body {
      white-space: pre-wrap;
      word-break: break-all;
      line-height: 1.8;

      /deep/ .template-variable {
        color: #1890ff;
        background: rgba(24, 144, 255, 0.08);
        padding: 0 4px;
        border-radius: 2px;
        font-weight: 500;
      }
    }
  }

  .content-tips {
    font-size: 12px;
    color: #8c8c8c;
    line-height: 20px;
    code {
      color: #1890ff;
      background: #f0f5ff;
      padding: 0 2px;
    }
  }

  .template-id-code {
    background: #f0f2f5;
    padding: 2px 8px;
    border-radius: 4px;
    color: #595959;
    font-family: Monaco, Consolas, monospace;
    font-size: 13px;
    border: 1px solid #d9d9d9;
  }

  .detail-title {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
  }
}
</style>
